export enum TemplateMode {
    AllQuestions = 'ALL_QUESTIONS',
    UseTemplate = 'USE_TEMPLATE',
    AsLastYear = 'AS_LAST_YEAR',
}

export function getLocalizedTemplateModes(): Record<TemplateMode, string> {
    return {
        ALL_QUESTIONS: $localize`:@@templateMode.allQuestions:Gebruik alle vragen`,
        USE_TEMPLATE: $localize`:@@templateMode.useTemplate:Gebruik sjabloon`,
        AS_LAST_YEAR: $localize`:@@templateMode.asLastYear:Gebruik zelfde vragen als vorig jaar`,
    };
}
